import React from 'react';

const Errow = () => {
    return (
        <div>
            <h1>Soryy! this drictory page not found</h1>
            <h4>404 not found page!!!!</h4>
        </div>
    );
};

export default Errow;